module.exports = __webpack_public_path__ + "1336aeb8a05f57114111a38e3835be81.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-18.png
// module id = 1768
// module chunks = 0